module.exports = __webpack_public_path__ + "static/media/MK 13 upd.5b62dd30.mp3";